<template>
  <div class="view-container">
    <div class="login_form">
      <form name="login">
          <label for="fname">Username</label><br>
          <input name="Username" type="text" id="fname"><br>
          <label for="pass">Password</label><br>
          <input name="Password" type="password" id="pass">
          <br>
          <button class="btn btn-primary login_submit" :style="{ 'background-color': accentColor }">
              Login
          </button>
          <router-link to="recover" style="color:#275a86">Forgot password?</router-link>
          <router-link to="register" class="btn btn-success register">Register</router-link>
      </form>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Login.vue.js";

export default {
  name: "Login",
  components: {
  },
  mixins: [view],
  data() {
    return {}
  },
  computed: {
      accentColor: function () {
        return this.$franchiseAccentColor;
      }
  },
  created() {
    if(this.$franchiseID == null){
          this.$router.push('Franchise');
      }
  },
  mounted() {
    document.querySelector('form[name=login] button.login_submit').addEventListener("click", this.login);
  }
};
</script>
<style scoped>
    @import './Login.vue.css'; 
</style>
